import PropTypes from 'prop-types';
import React from 'react';
import { Card, Form, Col, Button } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import FieldInput from '../../../components/FieldInput';

export const FormCode =
    ({ handleSubmit, pristine, reset, submitting, heading, handleSave, handleCancel }) => {

        return (<Form onSubmit={handleSubmit(handleSave)}>
            <Form.Row>
                <Form.Group as={Col}>
                    <Card style={{ width: '15rem' }}>
                        <Card.Body>
                            <Card.Title>Passo 1</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Apresentar o código de barras</Card.Subtitle>
                            <Card.Text>
                                Aproxime a nota não fiscal do leitor de código de barras
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Form.Group>
                <Form.Group as={Col}>
                    <Card style={{ width: '15rem' }}>
                        <Card.Body>
                            <Card.Title>Passo 2</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Preparando movimentação</Card.Subtitle>
                            <Card.Text>
                                Aguarde enquanto o sistema finaliza o processo de pesagem
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Form.Group>
                <Form.Group as={Col}>
                    <Card style={{ width: '15rem' }}>
                        <Card.Body>
                            <Card.Title>Passo 3</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Aguardar impressão</Card.Subtitle>
                            <Card.Text>
                                Favor aguardar a impressão do comprovante de pesagem
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Form.Group>

                <Form.Group as={Col}>
                    <Card style={{ width: '15rem' }}>
                        <Card.Body>
                            <Card.Title>Passo 4</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Nota</Card.Subtitle>
                            <Card.Text>
                                Retirar a nota ao lado
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Form.Group>

            </Form.Row>

            <Form.Row>
                <Form.Group as={Col}>
                    <Field
                        TypeOf={Form.Control}
                        id="codigo"
                        type="textarea"
                        name="codigo"
                        label="Código"
                        placeholder="Código de barras"
                        component={FieldInput}
                        focus={true}
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row >
                {/* <Col>


                    <Button variant="secondary" className="btn-danger btn-sm" onClick={handleCancel}>
                        Cancelar
                    </Button>

                </Col> */}
                <Col >
                    <Button type="submit" disabled={submitting} className="btn-sm">
                        Salvar
                    </Button>
                </Col>
            </Form.Row>
        </ Form>);

    }

FormCode.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    heading: PropTypes.string.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired
};


export default reduxForm({
    form: 'FormCode',
})(FormCode);